<form [formGroup]="form">
  <h3 translate="engagement/send-message/choose-sender-recipient/title"></h3>
  <div class="form-row">
    <div translate="engagement/send-message/choose-sender-recipient/from"></div>
    <app-select optionTemplateName="site-icon" [control]="form.controls.from" [items]="accounts"></app-select>
  </div>

  <div class="form-row recipient">
    <div class="recipient-line-to" translate="engagement/send-message/choose-sender-recipient/to"></div>
    <div *ngIf="engagementService.strategy.externalUser; else searchExternalUserTemplate" class="recipient-found">
      <mat-chip-list>
        <mat-chip (removed)="clearResult()">
          {{ engagementService.strategy.externalUser }}
          <button matChipRemove *ngIf="!engagementService.strategy.isCRMMode">
            <ion-icon name="close-circle-outline"></ion-icon>
          </button>
        </mat-chip>
      </mat-chip-list>
      <div *ngIf="!engagementService.strategy.isCRMMode">
        <mat-checkbox [formControl]="consentCtrl">
          <span
            translate="engagement/send-message/choose-sender-recipient/confirm-consent"
            [translateParams]="{ brand: brandName }"></span>
        </mat-checkbox>
      </div>
    </div>
    <ng-template #searchExternalUserTemplate>
      <form [formGroup]="recipientForm">
        <div class="search-external-user" *ngIf="!checkingRecipient; else checkingTemplate">
          <ng-container *ngTemplateOutlet="searchByPhoneTemplate"></ng-container>
          <ng-container *ngIf="engagementService.channelType === SiteTypeEnum.Kakaotalk">
            <div translate="OR"></div>
            <mat-form-field>
              <mat-label translate="engagement/send-message/choose-sender-recipient/kakaotalk-app-user-id"></mat-label>
              <input
                autocomplete="off"
                formControlName="appUserId"
                type="text"
                matInput
                tabindex="3"
                (keydown.enter)="searchExternalUser(EngagementUserIdTypeEnum.APP_USER_ID)" />
              <ion-icon
                tabindex="4"
                matSuffix
                name="search"
                (keydown.enter)="searchExternalUser(EngagementUserIdTypeEnum.APP_USER_ID)"
                (click)="searchExternalUser(EngagementUserIdTypeEnum.APP_USER_ID)"></ion-icon>
            </mat-form-field>
            <div translate="OR"></div>
            <mat-form-field>
              <mat-label translate="engagement/send-message/choose-sender-recipient/kakaotalk-user-key"></mat-label>
              <input
                autocomplete="off"
                formControlName="userKey"
                type="text"
                matInput
                tabindex="5"
                (keydown.enter)="searchExternalUser(EngagementUserIdTypeEnum.USER_KEY)" />
              <ion-icon
                tabindex="6"
                matSuffix
                name="search"
                (keydown.enter)="searchExternalUser(EngagementUserIdTypeEnum.USER_KEY)"
                (click)="searchExternalUser(EngagementUserIdTypeEnum.USER_KEY)"></ion-icon>
            </mat-form-field>
          </ng-container>
        </div>
      </form>
    </ng-template>

    <ng-template #searchByPhoneTemplate>
      <mat-form-field
        floatLabel="always"
        class="button-phone-number"
        [class.mat-form-field-invalid]="form.controls.to.hasError('invalid-number')">
        <input hidden matInput [formControl]="$any(recipientForm.get('phoneNumber'))" />
        <input
          *ngIf="userCountryCode"
          class="tel-input-container"
          #phoneInput
          type="tel"
          matInput
          appTelInput
          [telInputOptions]="{ initialCountry: userCountryCode, useFullscreenPopup: true }"
          [telNumber]="telInputInit()"
          (blur)="isPhoneNumberButtonValid()"
          (keydown.enter)="searchExternalUserByPhoneNumber()"
          (telInputChange)="phoneInputChanged($event)"
          (intlTelInputObject)="telInputObject($event)"
          tabindex="1" />
        <ion-icon
          tabindex="2"
          matSuffix
          name="search"
          (keydown.enter)="searchExternalUserByPhoneNumber()"
          (click)="searchExternalUserByPhoneNumber()"></ion-icon>
      </mat-form-field>
    </ng-template>
  </div>
  <ng-template #checkingTemplate>
    <span class="connecting">
      <app-loader></app-loader>
      <span class="text-muted" translate="engagement/send-message/choose-sender-recipient/checking"></span>
    </span>
  </ng-template>

  <ion-button
    *ngIf="engagementService.channelType === SiteTypeEnum.Kakaotalk"
    (click)="chooseWriteMessage()"
    [disabled]="canNotChoose">
    <span translate="engagement/send-message/choose-sender-recipient/choose-write-message"></span>
  </ion-button>

  <ion-button (click)="chooseTemplateMessage()" [disabled]="canNotChoose">
    <span translate="engagement/send-message/choose-sender-recipient/choose-template-message"></span>
  </ion-button>
</form>
